import { STORE_API } from 'modules/stores/api/stores-api'
import { useFetch } from 'shared/hooks/use-fetch'
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types'

export const useStoreItemActions = () => {
  const { fetcher } = useFetch({ method: RequestMethodsEnum.post })

  const reorderItem = (itemId: number, position: number) =>
    fetcher(`${STORE_API}/items/${itemId}/change-position`, { position })

  return { reorderItem }
}
